export interface ReportColumn {
  field: string;
  headerName: string;
  minwidth: number;
  flex: number;
}

export interface ReportTemplate {
  id: string;
  name: string;
  endpoint: string;
  columns: ReportColumn[];
}

export const reportTemplates: { [key: string]: ReportTemplate } = {
  todayArrivals: {
    id: "todayArrivals",
    name: "Today Arrival",
    endpoint: "payloadestimatesapi/api/Payload/today/arrivals",
    columns: [
      { field: "localETD", headerName: "LocalETD", minwidth: 130, flex: 1 },
      { field: "orig", headerName: "Orig", minwidth: 90, flex: 1 },
      { field: "dest", headerName: "Dest", minwidth: 90, flex: 1 },
      { field: "flightNumber", headerName: "Flt", minwidth: 90, flex: 1 },
      { field: "aircraftReg", headerName: "Acft", minwidth: 140, flex: 1 },
      { field: "rank", headerName: "Payload Rank", minwidth: 90, flex: 1 },
      { field: "ttlpax", headerName: "TTL PAX", minwidth: 90, flex: 1 },
      { field: "childCount", headerName: "Child", minwidth: 90, flex: 1 },
      { field: "windComp", headerName: "Wind Comp", minwidth: 90, flex: 1 },
      { field: "weight", headerName: "Weight", minwidth: 90, flex: 1 },
      { field: "estAllowablePayload", headerName: "Allowable Payload", minwidth: 130, flex: 1 },
      { field: "estimatedVols", headerName: "Volunteers", minwidth: 90, flex: 1 },
      { field: "estimatedProtectedSeats", headerName: "Protected Seats ", minwidth: 90, flex: 1 },
      { field: "actualAllowablePayload", headerName: "Allowable Payload", minwidth: 130, flex: 1 },
      { field: "actualVols", headerName: "Volunteers", minwidth: 90, flex: 1 },
      { field: "actualProtectedSeats", headerName: "Protected Seats ", minwidth: 90, flex: 1 }
    ],
  },
  todayDeparture: {
    id: "todayDeparture",
    name: "Today Departure",
    endpoint: "payloadestimatesapi/api/Payload/today/departures",
    columns: [
      { field: "localETD", headerName: "LocalETD", minwidth: 130, flex: 1 },
      { field: "orig", headerName: "Orig", minwidth: 90, flex: 1 },
      { field: "dest", headerName: "Dest", minwidth: 90, flex: 1 },
      { field: "flightNumber", headerName: "Flt", minwidth: 90, flex: 1 },
      { field: "aircraftReg", headerName: "Acft", minwidth: 140, flex: 1 },
      { field: "rank", headerName: "Payload Rank", minwidth: 90, flex: 1 },
      { field: "ttlpax", headerName: "TTL PAX", minwidth: 90, flex: 1 },
      { field: "childCount", headerName: "Child", minwidth: 90, flex: 1 },
      { field: "windComp", headerName: "Wind Comp", minwidth: 90, flex: 1 },
      { field: "weight", headerName: "Weight", minwidth: 90, flex: 1 },
      { field: "estAllowablePayload", headerName: "Allowable Payload", minwidth: 130, flex: 1 },
      { field: "estimatedVols", headerName: "Volunteers", minwidth: 90, flex: 1 },
      { field: "estimatedProtectedSeats", headerName: "Protected Seats ", minwidth: 90, flex: 1 },
      { field: "actualAllowablePayload", headerName: "Allowable Payload", minwidth: 130, flex: 1 },
      { field: "actualVols", headerName: "Volunteers", minwidth: 90, flex: 1 },
      { field: "actualProtectedSeats", headerName: "Protected Seats ", minwidth: 90, flex: 1 }
    ],
  },
  tomorrowArrival: {
    id: "tomorrowArrival",
    name: "Tomorrow Arrival",
    endpoint: "payloadestimatesapi/api/Payload/tomorrow/arrivals",
    columns: [
      { field: "localETD", headerName: "LocalETD", minwidth: 130, flex: 1 },
      { field: "orig", headerName: "Orig", minwidth: 90, flex: 1 },
      { field: "dest", headerName: "Dest", minwidth: 90, flex: 1 },
      { field: "flightNumber", headerName: "Flt", minwidth: 90, flex: 1 },
      { field: "aircraftReg", headerName: "Acft", minwidth: 140, flex: 1 },
      { field: "rank", headerName: "Payload Rank", minwidth: 90, flex: 1 },
      { field: "ttlpax", headerName: "TTL PAX", minwidth: 90, flex: 1 },
      { field: "childCount", headerName: "Child", minwidth: 90, flex: 1 },
      { field: "windComp", headerName: "Wind Comp", minwidth: 90, flex: 1 },
      { field: "weight", headerName: "Weight", minwidth: 90, flex: 1 },
      { field: "estAllowablePayload", headerName: "Allowable Payload", minwidth: 130, flex: 1 },
      { field: "estimatedVols", headerName: "Volunteers", minwidth: 90, flex: 1 },
      { field: "estimatedProtectedSeats", headerName: "Protected Seats ", minwidth: 90, flex: 1 }
    ],
  },
  tomorrowDeparture: {
    id: "tomorrowDeparture",
    name: "Tomorrow Departure",
    endpoint: "payloadestimatesapi/api/Payload/tomorrow/departures",
    columns: [
      { field: "localETD", headerName: "LocalETD", minwidth: 130, flex: 1 },
      { field: "orig", headerName: "Orig", minwidth: 90, flex: 1 },
      { field: "dest", headerName: "Dest", minwidth: 90, flex: 1 },
      { field: "flightNumber", headerName: "Flt", minwidth: 90, flex: 1 },
      { field: "aircraftReg", headerName: "Acft", minwidth: 140, flex: 1 },
      { field: "rank", headerName: "Payload Rank", minwidth: 90, flex: 1 },
      { field: "ttlpax", headerName: "TTL PAX", minwidth: 90, flex: 1 },
      { field: "childCount", headerName: "Child", minwidth: 90, flex: 1 },
      { field: "windComp", headerName: "Wind Comp", minwidth: 90, flex: 1 },
      { field: "weight", headerName: "Weight", minwidth: 90, flex: 1 },
      { field: "estAllowablePayload", headerName: "Allowable Payload", minwidth: 130, flex: 1 },
      { field: "estimatedVols", headerName: "Volunteers", minwidth: 90, flex: 1 },
      { field: "estimatedProtectedSeats", headerName: "Protected Seats ", minwidth: 90, flex: 1 }
    ],
  }
};
